import type { FiltersConfig } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import { filtersConfigStatusMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filtersConfig";
import type { OrderedSearchFilterInstance, SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import type { ILeadsSearchDescriptionDto } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";
import type { ISiCountryService } from "app/pages/sales-intelligence/services/siCountryService";
import type { ProfilesResponseDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";

import createApplyContactFiltersFilter from "../models/ApplyContactFiltersFilter/factory";
import createContactDetailsFilter from "../models/ContactDetailsFilter/factory";
import createContactLimitResultsFilter from "../models/ContactLimitResultsFilter/factory";
import createEmployeeLocationFilter from "../models/EmployeeLocationFilter/factory";
import createEmployeePersonasFilter from "../models/EmployeePersonasFilter/factory";

const EMPTY_FILTERS_CONFIG: OrderedSearchFilterInstance[] = [];

const withOrder = (filter: SearchFilterInstance, order: number): OrderedSearchFilterInstance => {
    filter.order = order;
    return filter as OrderedSearchFilterInstance;
};

type ContactsFactoryDeps = {
    filtersDescription?: Pick<ILeadsSearchDescriptionDto, "employeeLocation" | "employeeProfile">;
    profilesResponse?: ProfilesResponseDto;
    filtersCountryService: ISiCountryService;
};

export const createContactsFilterConfig = (deps: ContactsFactoryDeps): FiltersConfig<OrderedSearchFilterInstance[]> => {
    if (!deps.filtersDescription || !deps.profilesResponse) {
        return { filtersList: EMPTY_FILTERS_CONFIG, status: filtersConfigStatusMap.pending };
    }

    return {
        status: filtersConfigStatusMap.ready,
        filtersList: [
            withOrder(createApplyContactFiltersFilter(), 10),

            withOrder(
                createEmployeeLocationFilter(deps.filtersDescription.employeeLocation, deps.filtersCountryService),
                420,
            ),
            withOrder(
                createEmployeePersonasFilter(deps.profilesResponse, deps.filtersDescription.employeeProfile),
                430,
            ),
            withOrder(createContactDetailsFilter(), 440),
            withOrder(createContactLimitResultsFilter(), 450),
        ],
    };
};
